import Vue from 'vue'
import Router from 'vue-router'
import beforeEach from './beforeEach'
// Components routes
import Erro404 from '../views/404/index'
import Dashboard from '../views/dashboard/index'
import Login from '../views/login/index'
import Company from '../views/company/index'
import User from '../views/user/index'
import ResultMeter from '../views/resultMeter/index'
import SaleSegregation from '../views/saleSegregation/index'
import SaleMonitoring from '../views/saleMonitoring/index'
import PersonalBudget from '../views/personalBudget/index'
import PriceFormation from '../views/priceFormation/index'
import DayleSchedule from '../views/dayleSchedule/index'
import ResultDemonstrative from '../views/resultDemonstrative/index'
import Support from '../views/support/index'
import PurchaseFlow from '../views/purchaseFlow/index'
import PurchaseMonitoring from '../views/purchaseMonitoring/index'
import WorkingCapital from '../views/workingCapital/index'
import FinancialCalculation from '../views/financialCalculation/index'
import IndicatorsAnalysis from '../views/indicatorsAnalysis/index'
import PreliminaryDiagnosis from '../views/preliminaryDiagnosis/index'
import SaleOrigin from '../views/saleOrigin/index'
import StockVariation from '../views/stockVariation/index'
import FinancingControl from '../views/financingControl/index'
import ActionPlan from '../views/actionPlan/index'
import Product from '../views/product/index'
import StockControl from '../views/stockControl/index'
import BankStatement from '../views/bankStatement/index'
// Containers
const Full = () => import(/* webpackChunkName: "full" */ '../layouts/Full.vue')
const Clean = () => import(/* webpackChunkName: "clean" */ '../layouts/Clean.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Full',
      component: Full,
      children: [
        Dashboard.route,
        Company.create,
        Company.edit,
        Company.list,
        User.create,
        User.edit,
        User.profile,
        User.list,
        ResultMeter.index,
        SaleSegregation.index,
        SaleSegregation.createSeller,
        SaleSegregation.createSection,
        SaleSegregation.editSeller,
        SaleSegregation.editSection,
        SaleMonitoring.index,
        PersonalBudget.index,
        PersonalBudget.config,
        PriceFormation.index,
        DayleSchedule.index,
        DayleSchedule.week,
        ResultDemonstrative.index,
        ResultDemonstrative.config,
        Support.index,
        PurchaseFlow.index,
        PurchaseMonitoring.index,
        WorkingCapital.index,
        FinancialCalculation.index,
        IndicatorsAnalysis.index,
        PreliminaryDiagnosis.index,
        SaleOrigin.index,
        StockVariation.index,
        FinancingControl.index,
        FinancingControl.create,
        FinancingControl.edit,
        ActionPlan.index,
        ActionPlan.create,
        ActionPlan.edit,
        Product.index,
        StockControl.index,
        BankStatement.index
      ]
    },
    {
      path: '/',
      name: 'Clean',
      component: Clean,
      children: [
        Login.route,
        Company.select,
        Erro404.route
      ]
    }
  ]
})

// const getRoutesList = (routes, pre) => {
//   return routes.reduce((array, route) => {
//     const path = `${pre}${route.path}`
//
//     if (route.path !== '*') {
//       array.push(path)
//     }
//
//     if (route.children) {
//       array.push(...getRoutesList(route.children, `${path}`))
//     }
//
//     return array
//   }, [])
// }
// const getRoutesXML = () => {
//   const list = getRoutesList(router.options.routes, 'https://meugestor.app')
//     .map(route => `<url><loc>${route}</loc></url>`)
//     .join('\r\n')
//   return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
//     ${list}
//   </urlset>`
// }
// const writeSiteMap = async () => {
//   const content = getRoutesList(router.options.routes, 'https://meugestor.app')
//   console.log(JSON.stringify(content))
// }
// writeSiteMap()
router.beforeEach(beforeEach)

export default router
